module.exports = __webpack_public_path__ + "82d7cc79095e6e11c23e96ac38b6bbac.pdf";